import type { Dayjs } from 'dayjs';

import dayjs, { EN_VEHICLE_COUNTDOWN_LOCALE } from 'Utilities/dayjs';

import { TIME_IN_MS } from './dateHelpers/dateHelpers';

export const generateTimeRemainingText = (date?: Date | Dayjs | null): string => {
	const now = dayjs().locale(EN_VEHICLE_COUNTDOWN_LOCALE);
	const targetDate = dayjs(date ?? now);
	const isValidDate = targetDate.isValid();
	const diff = targetDate.diff(now);

	// TODO: Refactor this to use a more stable approach
	// We are doing this as we can't override the rounding function of dayjs locally, and we want to round down to the nearest minute/hour.
	const shouldRoundDownMinute = diff >= TIME_IN_MS.minute * 1.5;
	const shouldRoundDownHour = diff >= TIME_IN_MS.hour * 1.5;

	const getTimeRemaining = () => {
		if (shouldRoundDownHour) {
			return now.to(targetDate.subtract(30, 'minutes'));
		}

		if (shouldRoundDownMinute) {
			return now.to(targetDate.subtract(30, 'seconds'));
		}

		return now.to(targetDate);
	};

	const text = diff < TIME_IN_MS.minute ? 'Less than 1m' : getTimeRemaining();

	return diff < 1 || !isValidDate ? '' : text;
};
